<template>
  <div id="app">
    <map-component><search-bar-component></search-bar-component></map-component>
    <info-panel-component></info-panel-component>
    <metadata-component></metadata-component>
    <facet-search-component></facet-search-component>
  </div>
</template>



<script>
import mapComponent from "./components/map-component.vue";
import metadataComponent from "./components/metadata-component.vue";
import searchBarComponent from "./components/search-bar-component.vue";
import infoPanelComponent from "./components/info-panel-component.vue";
import facetSearchComponent from "./components/facet-search-component.vue";

export default {
  name: "App",
  components: {
    mapComponent,
    metadataComponent,
    searchBarComponent,
    infoPanelComponent,
    facetSearchComponent
  }
};
</script>


